import React from 'react';
import { useChatPlayContext } from '@provider/ChatPlayProvider';
import Statistics from '../../popup/Statistics';
import ChatBanner from '../ChatBanner';
import ChatEndingComment from './ChatEndingComment';

const ChapterEnding = () => {
  const { endingPopupInfo } = useChatPlayContext();

  return (
    <>
      {endingPopupInfo?.ending && (
        <>
          <Statistics ending={endingPopupInfo?.ending} />
          <ChatEndingComment />
        </>
      )}
      <ChatBanner />
    </>
  );
};

export default ChapterEnding;
